import React from "react";
import Skeleton from "src/components/Skeleton";

type CheckboxProps = {
	value?: boolean;
	onChange: (value: boolean) => void;
	label?: any;
	className?: string;
};

const Checkbox = ({ value, onChange, label, className }: CheckboxProps) => {
	return (
		<div
			onClick={() => onChange(!value)}
			className={`flex gap-2 ${className || ""}`}
		>
			<div
				className={`
                ${className} 
                border-2 cursor-pointer h-5 w-5 flex text-white items-center justify-center rounded-sm 
                transition-all hover:border-dark group-hover:bg-primary group-hover:border-primary ${
					value ? "border-dark" : "border-dark-200 "
				}
                ${value && "bg-dark"}`}
			>
				<i
					className={`fas fa-check text-[10px] opacity-${
						value ? 100 : 0
					} transition-all group-hover:opacity-100 hover:opacity-100`}
				/>
			</div>
			{label && <span className="mb-0">{label}</span>}
		</div>
	);
};

interface LoaderProps {
	className?: string;
	label?: boolean;
}

const Loader = ({ className, label }: LoaderProps) => {
	return (
		<div className={`flex gap-2 ${className || ""}`}>
			<Skeleton className="h-5 w-5 rounded-sm" />
			{label && <Skeleton className="h-5 w-18" />}
		</div>
	);
};

Checkbox.Loader = Loader;

export default Checkbox;
